import styles from "./Select.module.css";

export default function Select({ id, label, value, onChange, options, required }) {
  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label}
        {required && " *"}
      </label>
      <select id={id} name={id} value={value} onChange={onChange} required={required} className={styles.select}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
